import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { getInitials } from "../../utils";
import "./ProfileMenu.scss";

function ProfileMenu({ email, onSignOut }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="profile-menu" ref={ref}>
      <button className="profile-avatar" onClick={() => setOpen((o) => !o)}>
        {getInitials(email)}
      </button>

      {open && (
        <div className="profile-dropdown">
          <div className="profile-email">{email}</div>
          <hr className="profile-divider" />
          <button className="profile-logout-btn" onClick={onSignOut}>
            🚪 Logout
          </button>
        </div>
      )}
    </div>
  );
}

ProfileMenu.propTypes = {
  email: PropTypes.string,
  onSignOut: PropTypes.func,
};

export default ProfileMenu;
